/**
 * Strip slide-authored HTML that can interfere with the app shell or trigger
 * navigation while preserving the visible slide structure.
 */
export const sanitizeSlideHtml = (html: string): string => {
  let sanitized = html;

  sanitized = sanitized.replace(/<meta[^>]*name=["']viewport["'][^>]*>/gi, "");
  sanitized = sanitized.replace(
    /<form([^>]*)>/gi,
    '<div data-was-form="true"$1>',
  );
  sanitized = sanitized.replace(/<\/form>/gi, "</div>");
  sanitized = sanitized.replace(
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
    "",
  );
  sanitized = sanitized.replace(
    /\s(onclick|onsubmit|onload|onerror|onmousedown|onmouseup|ontouchstart|ontouchend)="[^"]*"/gi,
    "",
  );

  return sanitized;
};
